import { render } from "./faq-index.vue?vue&type=template&id=d15d54b4"
import script from "./faq-index.vue?vue&type=script&lang=js"
export * from "./faq-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__